// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3kRJ3","icon":"SortAdornment_icon__19GTl","up":"SortAdornment_up__hFzZ6","down":"SortAdornment_down__1T5k0","active":"SortAdornment_active__2DkCq"};